import { observable, action } from "mobx";
import * as api from "../services/api";
import Cookies from "js-cookie";
import RiderStore from "./RiderStore"
import moment from 'moment';

class CheckInStore {
  @observable attendanceId = null;
  
  @observable isSubmitted = false;
  @observable isSubmitting = false;
  
  @observable currentPage = 1
  @observable isReturn = false
  @observable name = ""
  @observable
  checkinData = {
    rider_id: "",
    backpack_id: "",
    cooler_bag_id: "",
    checklist_signed: false,
    backup: false,
    returned_cash: "",
    dispatches: [],
    attendance_id: null,
    return_only: false
  };
  @observable dispatches = {}
  
  @observable selectedDispatches = []
  
  @observable previous = {}
  
  @action resetCheckInData = () => {
    this.attendanceId = null;
    
    this.isSubmitted = false;
    this.isSubmitting = false;
    
    this.currentPage = 1
    this.isReturn = false
    this.name = ""
    this.checkinData = {
      rider_id: "",
      backpack_id: "",
      cooler_bag_id: "",
      checklist_signed: false,
      backup: false,
      returned_cash: "",
      dispatches: [],
      attendance_id: null,
      return_only: false
    }
    this.previous = {}
  }
  
  @action
  toggleNav = (e) => {
    e.preventDefault()
    this.isReturn = !this.isReturn
  }
  
  @action
  handleChange = e => {
    let value = e.target.value;
    let name = e.target.name;
    this.checkinData[name] = value;
  };

  @action
  handleCheck = e => {
    let name = e.target.name;
    this.checkinData[name] = !this.checkinData[name];
  };

  @action
  handleSelect = e => {
    this.checkinData.rider_id = e.id
    this.name = e.name
  }

  @action
  riderCheckIn() {
    this.isSubmitting = true
    this.checkinData.dispatches = this.checkinData.dispatches.map(dispatch => dispatch.value)
    api
      .riderCheckIn(this.checkinData)
      .then(() => {
        this.isSubmitted = true;
      })
      .catch(e => alert(e))
      .finally(() => this.isSubmitting = false)
  }
  
  @action 
  riderReturns() {
    this.isSubmitting = true
    const data = this.checkinData
    api
      .riderCheckIn({
        rider_id: data.rider_id,
        backpack_id: data.backpack_id,
        cooler_bag_id: data.cooler_bag_id,
        returned_cash: data.returned_cash,
        checklist_signed: data.checklist_signed,
        attendance_id: data.attendance_id,
      })
      .then(() => {
        this.isSubmitted = true
      })
      .catch(e => alert(e))
      .finally(() => this.isSubmitting = false)
  }
  
  @action
  updateRider = (id) => {
    api
      .getRider(id)
      .then(res => {
        RiderStore.rider = res
        const selectedRider = RiderStore.checkedInRiders.find(rider => {
          return rider.rider_id === res.rider_id
        })
        RiderStore.rider.name = selectedRider.name
        this.checkinData.attendance_id = RiderStore.rider.attendance_id
      })
      .catch(e => alert(e));
  }

  isDisabled = () => {
    if (this.isReturn) {
      return !this.checkinData.backpack_id && !this.checkinData.cooler_bag_id && !this.checkinData.returned_cash
    } else {
      if (this.currentPage === 1) {
        return !this.checkinData.rider_id;
      }
      if (this.currentPage === 2) {
        const returnedCash = () => {
          if (this.checkinData.returned_cash === 0) {
            return true
          } else {
            return this.checkinData.returned_cash
          }
        }
        return (
          !this.checkinData.checklist_signed ||
          !returnedCash()
        );
      }
      if (this.currentPage === 3) {
        return this.checkinData.dispatches.length === 0 || this.isSubmitting
      }
    }
  };

  @action
  next = () => {
    api.getRiderDetails(this.checkinData.rider_id)
        .then(res => {
          this.previous = res;
          if (res.suspended) {
            const date = res.suspension_end_date ? moment(res.suspension_end_date).format('MMMM Do') : '';
            const reason = res.suspension_reason ? `Reason: ${ res.suspension_reason }` : '';
            alert(`This rider is currently suspended until ${ date }. ${ reason }`);
          } else {
            this.currentPage++;
          }
        })
        .catch(e => alert(e))
  };

  @action
  back = () => {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  };

  @action
  getDispatches = () => {
    api.getDispatches(Cookies.get('token'))
        .then(res => {
          this.dispatches = res.dispatches
              .map(dispatch => {
                let dispatchObj = {}
                dispatchObj.value = dispatch.dispatch_no
                dispatchObj.label = `Dispatch ${dispatch.dispatch_no}`
                return dispatchObj
              })
              .sort((a, b) => a.value - b.value)
        })
        .catch(e => alert(e))
  }

    @action
    getRiderAttendance = id => {
      this.attendanceId = id;
      this.currentPage = 2
      let selectedRider
      api.getRiderAttendance(id)
        .then(res => {
          RiderStore.rider = res
          if (RiderStore.checkedInRiders.length === 0) {
            api.getRidersCheckedIn(Cookies.get('token'))
              .then(r => {
                selectedRider = r.list.find(rider => rider.attendance_id === res.attendance_id)
              })
          } else {
            selectedRider = RiderStore.checkedInRiders.find(rider => rider.attendance_id === res.attendance_id)
            this.name = selectedRider.name
          }  
          if (res.backup === null) {
            res.backup = false
          } 
          this.checkinData = res
        })
        .catch(e => alert(e))
    }
}

const store = new CheckInStore();
export default store;



// WEBPACK FOOTER //
// ./src/stores/CheckInStore.js